import { render, staticRenderFns } from "./OnboardingUserDetails.vue?vue&type=template&id=8f085b92&scoped=true"
import script from "./OnboardingUserDetails.vue?vue&type=script&lang=js"
export * from "./OnboardingUserDetails.vue?vue&type=script&lang=js"
import style0 from "./OnboardingUserDetails.vue?vue&type=style&index=0&id=8f085b92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f085b92",
  null
  
)

export default component.exports